/**
 * 门户主体角色枚举
 */
export const MainBodyRole = {
  // 个人角色
  PERSONAL_ROLE: {
    value: 'personal',
    label: '个人用户'
  },
  // 机构业务员
  SALESMAN_ROLE: {
    value: 'salesman',
    label: '机构业务员'
  },
  // 企业超级管理员
  SUPER_ADMIN_ROLE: {
    value: 'super_admin',
    label: '超级管理员'
  },
  // 企业管理员
  ADMIN_ROLE: {
    value: 'admin',
    label: '管理员'
  }
}

/**
 * 根据角色值获取枚举对象
 * @param {string} role - 角色值
 * @returns {Object} 枚举对象
 */
export function getMainBodyRoleEnum(role) {
  return Object.values(MainBodyRole).find(item => item.value === role) || null
}

/**
 * 根据角色值获取角色标签
 * @param {string} role - 角色值
 * @returns {string} 角色标签
 */
export function getMainBodyRoleLabel(role) {
  const roleEnum = getMainBodyRoleEnum(role)
  return roleEnum ? roleEnum.label : role
}
